/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Spotting_Event_Group_HelpInputs */

const en_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Spotting List will normally contain your subtitles with dialogue and speaker information.`)
};

const fr_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La liste de reperage contient generalement vos sous-titres avec dialogue et informations de locuteur.`)
};

const de_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sprecherliste enthält normalerweise Ihre Untertitel mit Dialog- und Sprecherinformationen.`)
};

const it_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di solito, l'elenco di individuazione conterrà i sottotitoli con informazioni sui dialoghi e sull'oratore.`)
};

const ru_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В списке для опознания обычно содержатся ваши субтитлы с информацией о диалогах и говорящих.`)
};

const es_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La lista de localización normalmente contendrá subtítulos con diálogos e información del orador.`)
};

const zh_cn2_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕列表通常会包含对话和说话人信息等字幕内容。`)
};

const ja_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポッティング リストには通常、会話と話者の情報を含む字幕が含まれます。`)
};

const hi_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पॉटिंग लिस्ट में आमतौर पर संवाद और वक्ता की जानकारी सहित आपके उपशीर्षक शामिल होंगे।`)
};

const pt_pt2_ccsl_export_spotting_event_group_help = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lista de identificação de atores geralmente contém as legendas com informações sobre os diálogos e os falantes.`)
};

/**
* | output |
* | --- |
* | "The Spotting List will normally contain your subtitles with dialogue and speaker information." |
*
* @param {Ccsl_Export_Spotting_Event_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_spotting_event_group_help = /** @type {((inputs?: Ccsl_Export_Spotting_Event_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Spotting_Event_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "de") return de_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "it") return it_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "ru") return ru_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "es") return es_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "ja") return ja_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "hi") return hi_ccsl_export_spotting_event_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_spotting_event_group_help(inputs)
	return en_ccsl_export_spotting_event_group_help(inputs)
});